/**
 * Generic Delete Dialog Component
 * Reutilizável para qualquer entidade do sistema
 */

import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";

interface GenericDeleteDialogProps<T> {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  item: T | null;
  onConfirm: () => void;
  isLoading?: boolean;
  entityName: string;
  getItemLabel: (item: T) => string;
  children?: React.ReactNode;
}

export function GenericDeleteDialog<T>({
  open,
  onOpenChange,
  item,
  onConfirm,
  isLoading = false,
  entityName,
  getItemLabel,
  children,
}: GenericDeleteDialogProps<T>) {
  if (!item) return null;

  const itemLabel = getItemLabel(item);

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Excluir {entityName}</AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div>
              {children || (
                <>
                  Tem certeza que deseja excluir {entityName.toLowerCase() === "o" || entityName.toLowerCase().endsWith("o") ? "o" : "a"}{" "}
                  {entityName.toLowerCase()} <strong>{itemLabel}</strong>?
                  Esta ação não pode ser desfeita.
                </>
              )}
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={isLoading}>Cancelar</AlertDialogCancel>
          <AlertDialogAction
            onClick={onConfirm}
            disabled={isLoading}
            className="bg-destructive hover:bg-destructive/90"
          >
            {isLoading ? "Excluindo..." : "Excluir"}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
